import { Grid, IconButton, Tooltip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { SamplesListActionsProps } from './props';
import { SAMPLES_EDIT } from '../../../../../../routes/paths';
import { MouseEventHandler } from 'react';

export const SamplesListActions = ({ id }: SamplesListActionsProps) => {
    const handleEdit: MouseEventHandler<HTMLButtonElement> | undefined = (
        e
    ) => {
        e.stopPropagation();
        window.open(`${SAMPLES_EDIT}/${id}`, '_blank');
    };

    return (
        <Grid textAlign="left" width="100%">
            <Tooltip title="Editar">
                <IconButton size="small" onClick={handleEdit}>
                    <EditIcon type="submit" sx={{ color: 'primary.main' }} />
                </IconButton>
            </Tooltip>
        </Grid>
    );
};
